import { Button } from "devextreme-react/button";
import { DateBox } from "devextreme-react/date-box";
import moment from "moment";
import React, { Fragment, useEffect, useState, useRef } from "react";
import styled from "styled-components";
import LoaderThreeDot from "../../Loader/LoaderThreeDot";
import axiosInstance from "../../Middleware/axiosInstance";

const SlotWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`;

const SlotAvailabilityContainer = styled.div`
width:100%;
padding:5px;
border:1px solid lightgrey;
height: 100%;
display: flex;
flex-direction: column;
`;

const SlotContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  ${"" /* border-bottom: 1px solid lightgrey; */}
  ${"" /* border-left: 1px solid lightgrey; */}
`;

const Time = styled.div`
  border: 1px solid lightgrey;
  padding: 5px 15px;
  border-radius: 3px;
  ${'' /* width: 23%; */}
  display: flex;
  align-items: center;
  margin: 5px;
  &:hover {
    cursor: pointer;
    background-color: lightgrey;
  }
`;

const LoadingText = styled.div`
  display: flex;
  height: 85%;
  justify-content: center;
  align-items: center;
`;

const SelectedTimeSlotContainer = styled.div`
width:100%;
align-items:center;
gap:10px;
padding:10px;
font-size:15px;
background:lightblue;
`
const COMRADSlotAvailabilityControl = ({
    slotSelectionHandler,
    conversationID,
    disableSlotSelectionControl,
    center_id,
    dataFromApiRequestedCallback
}) => {
    const [disableSlotSelectionControlState, setDisableSlotSelectionControlState] = useState(disableSlotSelectionControl)
    const [availableSlotData, setAvailableSlotData] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

    const [isSlotFetching, setIsSlotFetching] = useState(false);
    const [isCalendarFetching, setIsCalendarFetching] = useState(false);

    const [selectedRoom, setSelectedRoom] = useState(null);
    const [selectedCenterName, setSelectedCenterName] = useState(null);
    const [slotAvailabilityStartAndEndDate, setSlotAvailabilityStartAndEndDate] = useState(null)
    const [slotUnavailabilityDates, setSlotUnavailabilityDates] = useState(null)
    const [firstAvailableSlotDate, setFirstAvailableSlotDate] = useState(null)

    const slotAvailabilityDatesRawData = useRef(null)
    const selectedCenterDetails = useRef({ center_id: null, center_name: null })
    const dateBoxRef = useRef(null);

    const getCentersWhereSlotIsAvailable = (date) => {
        for (var i = 0; i < slotAvailabilityDatesRawData.current.length; i++) {
            if (slotAvailabilityDatesRawData.current[i].date === date) {
                return slotAvailabilityDatesRawData.current[i].centers_where_service_available;
            }
        }
    }
    useEffect(() => {
        setDisableSlotSelectionControlState(disableSlotSelectionControl)
    }, [disableSlotSelectionControl])
    useEffect(() => {
        console.log("Fetching availability dates.");
        setIsCalendarFetching(true);
        dataFromApiRequestedCallback(true)
        axiosInstance().get(`/oi/chatty/GetAvailabilityCalendar/${conversationID}?center_id=${center_id}`).then(
            (response) => {
                slotAvailabilityDatesRawData.current = response.data?.data
                if (slotAvailabilityDatesRawData.current) {

                    let unavailableDates = new Array()
                    let firstAvailabilityDate = null;
                    slotAvailabilityDatesRawData.current.map((obj, index) => {
                        if (obj?.isAvailable === false) {
                            unavailableDates.push(new Date(obj.date))
                        }
                        if (firstAvailabilityDate === null && obj?.isAvailable === true) {
                            firstAvailabilityDate = new Date(obj.date)
                        }

                    });

                    setSlotAvailabilityStartAndEndDate([moment(slotAvailabilityDatesRawData.current[0].date), moment(slotAvailabilityDatesRawData.current[slotAvailabilityDatesRawData.current.length - 1].date)])
                    setSlotUnavailabilityDates(unavailableDates)
                    setFirstAvailableSlotDate(firstAvailabilityDate)
                    setIsCalendarFetching(false);
                    dataFromApiRequestedCallback(false)
                    if (firstAvailabilityDate != null) {
                        fetchAvailableSlots(firstAvailabilityDate);
                    }
                }
            }
        ).catch((error) => { console.error(error); setIsCalendarFetching(false); dataFromApiRequestedCallback(false); })

    }, [center_id])


    const RenderSlots = ({ center_id, center_name, availableSlots }) => {
        return (
            <Fragment>
                {availableSlots?.length > 0 &&
                    availableSlots.map((slot) => (
                        <Time
                            onClick={() => {
                                if (disableSlotSelectionControlState) return;
                                selectedCenterDetails.current = { center_id: center_id, center_name: center_name };
                                setSelectedTimeSlot(slot);
                                setSelectedRoom(slot.room_name);
                            }}
                            style={{
                                background: (selectedTimeSlot?.schedule === slot.schedule && center_id === selectedCenterDetails.current.center_id) && "#2185D0",
                                color: (selectedTimeSlot?.schedule === slot.schedule && center_id === selectedCenterDetails.current.center_id) && "white",
                            }}
                        >
                            <div>
                                {moment(slot?.schedule).format("hh:mm A")}
                            </div>
                        </Time>
                    ))}
            </Fragment>
        );
    };

    const _fetchAvailableSlots2 = async (queryDate, each) => {
        try {
            const response = await axiosInstance().get(`/oi/chatty/GetAvailabilitySlots/${conversationID}?query_date=${moment(queryDate).format("yyyy-MM-DD")}&center_id=${each.center_id}`);
            return response;
        } catch (error) {
            return error
        }
    };

    const fetchAvailableSlots = async (date) => {
        if (dateBoxRef.current) {
            dateBoxRef.current.instance.close();
        }
        setIsSlotFetching(true);
        dataFromApiRequestedCallback(true)
        let query_date = moment(date).format("yyyy-MM-DD");
        let _centersSlotData = []
        let centersWhereSlotIsAvailable = getCentersWhereSlotIsAvailable(query_date)
        centersWhereSlotIsAvailable.map(each_center => {
            _centersSlotData.push({ center_id: each_center.center_id, center_name: each_center.center_name, available_slots: [], error_code: 0, error_description: '' })
        });

        const requests = _centersSlotData.map(each => { return _fetchAvailableSlots2(query_date, each) });
        const responses = await Promise.all(requests);
        for (const response of responses) {
            const date = new Date();
            for (var i = 0; i < _centersSlotData.length; i++) {
                if (_centersSlotData[i].center_id === response.data?.center_id) {
                    let error_code = response.data?.error_code;
                    let error_description = response.data?.error_description;
                    _centersSlotData[i].error_code = parseInt(error_code);
                    _centersSlotData[i].error_description = error_description;
                    _centersSlotData[i].day_specific_cost = response.data?.day_specific_cost;
                    if (_centersSlotData[i].error_code === 0) {
                        let slots_data = response.data?.available_slots;
                        // filter for unique slots.
                        let _unique_slot_idx = new Array()
                        let _unique_slots = new Array()
                        slots_data.map(each_slot => {
                            if (_unique_slot_idx.includes(each_slot.slot_idx) === false) {
                                _unique_slots.push(each_slot)
                                _unique_slot_idx.push(each_slot.slot_idx)
                            }
                        })
                        _centersSlotData[i].available_slots = _unique_slots;
                    }
                }
            }
        }
        setAvailableSlotData(_centersSlotData);
        setIsSlotFetching(false);
        dataFromApiRequestedCallback(false)
    }
    const getCostText = (day_specific_cost) => {
        console.log(day_specific_cost);
        let query_date = moment(dateBoxRef.current.instance.option("value")).format("DD-MMMM")
        let day_of_week = moment(dateBoxRef.current.instance.option("value")).format("dddd")
        if (day_specific_cost.additional_cost !== 0 && day_specific_cost.gap !== 0 && day_specific_cost.is_cost_approx === false) {
            return <div>The scan has an additional cost of <b>${day_specific_cost.additional_cost}</b> includes <b>${day_specific_cost.gap_cost}</b> gap on {day_of_week}, {query_date}</div>
        }
        if (day_specific_cost.additional_cost !== 0 && day_specific_cost.gap !== 0 && day_specific_cost.is_cost_approx === true) {
            return <div>The scan has an additional cost of around <b>${day_specific_cost.additional_cost}</b> includes <b>${day_specific_cost.gap_cost}</b> gap on {day_of_week}, {query_date}</div>
        }
        if (day_specific_cost.additional_cost !== 0 && day_specific_cost.gap === 0 && day_specific_cost.is_cost_approx === false) {
            return <div>The scan has an additional cost of <b>${day_specific_cost.additional_cost}</b> on {day_of_week}, {query_date}</div>
        }
        return <div>The scan may have an additional cost around of <b>${day_specific_cost.additional_cost}</b> on {day_of_week}, {query_date}</div>
    }   
    return (
        <SlotAvailabilityContainer>
            {selectedTimeSlot && <div>

                <SelectedTimeSlotContainer>
                    <div style={{ fontSize: "16px", }}><b>{selectedCenterDetails.current.center_name}</b></div>
                    <div style={{ display: "flex", gridTemplateColumns: "repeat(1fr,2fr)", gap: "20px" }}>
                        <div style={{ marginTop: "12px" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 5fr", gap: "10px" }}>
                                <div>Date:</div>
                                <div>{selectedTimeSlot?.schedule ? moment(selectedTimeSlot?.schedule).format("DD/MM/YYYY hh:mm A") : ""} </div>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 5fr", gap: "10px" }}>
                                <div>Room: </div>
                                <div>{selectedTimeSlot?.room_name ? selectedTimeSlot?.room_name : ""}</div>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 5fr", gap: "10px" }}>
                                <div>Res:</div>
                                <div> {selectedTimeSlot?.slot_text ? selectedTimeSlot?.slot_text : ""}</div>
                            </div>
                        </div>
                        <div style={{ height: "70px", alignItems: "flex-end", marginTop: "20px" }}><Button width={"150px"} height={"40px"} text="Confirm" icon="arrowright" rtlEnabled={true} type="success" onClick={() => { slotSelectionHandler(selectedCenterDetails.current.center_id, selectedCenterDetails.current.center_name, selectedTimeSlot, true); setDisableSlotSelectionControlState(true); }} disabled={disableSlotSelectionControlState}></Button></div>
                    </div>
                </SelectedTimeSlotContainer></div>}
            {/* Do not show date selection till slotAvailabilityDates is null */}
            <div style={{ marginTop: "10px" }}>{isCalendarFetching ? (
                <LoadingText>
                    <div style={{ display: "grid", gap: "10px", justifyItems: "center" }}>
                        <LoaderThreeDot />
                        <div style={{ fontSize: "16px" }}>Fetching calendar</div>
                    </div>
                </LoadingText>) : slotAvailabilityStartAndEndDate &&
            <DateBox
                ref={dateBoxRef}
                type="date"
                label=" Date "
                placeholder="DD/MM/YYYY"
                useMaskBehavior={true}
                displayFormat="dd/MM/yyyy"
                height={45}
                // opened={true}
                value={firstAvailableSlotDate}
                min={slotAvailabilityStartAndEndDate[0]}
                max={slotAvailabilityStartAndEndDate[1]}
                onValueChanged={(e) => fetchAvailableSlots(e.value)}
                disabledDates={slotUnavailabilityDates}
                disabled={disableSlotSelectionControlState || isSlotFetching}
            />
            }

            </div>
            {isCalendarFetching === false && <SlotWrapper>
                {isSlotFetching ? (
                    <LoadingText>
                        <div style={{ display: "grid", gap: "10px", justifyItems: "center" }}>
                            <LoaderThreeDot />
                            <div style={{ fontSize: "16px" }}>Fetching slots</div>
                        </div>
                    </LoadingText>
                ) : availableSlotData?.map(_each => {
                    return (
                        
                        <div style={{ marginTop: "5px", borderStyle: "solid", borderWidth: "1px", borderColor: "lightgrey" }}>
                            <div style={{ backgroundColor: "lightgray", paddingTop: "5px", paddingBottom: "5px", paddingLeft: "2px" }}>{_each.center_name}</div>
                            {(_each.error_code === 0 && _each.available_slots.length === 0) && (
                                <LoadingText style={{ fontSize: "17px" }}>
                                    {"No slots present."}
                                </LoadingText>
                            )}
                            {(_each.error_code === 0 && _each.available_slots.length > 0) && (

                                <Fragment>
                                    {_each.day_specific_cost && 
                                    <div style={{paddingLeft:"10px", color:"red"}}>
                                        {getCostText(_each.day_specific_cost)}   
                                    </div>}
                                    <SlotContainer>
                                        <RenderSlots center_id={_each.center_id} center_name={_each.center_name} availableSlots={_each.available_slots} />
                                    </SlotContainer>
                                </Fragment>
                            )}
                            {(_each.error_code != 0) && (
                                <LoadingText style={{ fontSize: "17px", color: "red", height: "30px", padding: "10px" }}>
                                    {" "}
                                    {_each.error_description}
                                </LoadingText>
                            )}
                        </div>
                    )
                })
                }
            </SlotWrapper>}
        </SlotAvailabilityContainer>
    );
};

export default COMRADSlotAvailabilityControl;
